
import React from 'react';
import { TourProvider } from '@reactour/tour';
import { WalkthroughContent } from './WelcomeWalkthrough';

const steps = [
  {
    selector: '[data-tour="welcome"]',
    content: ({ currentStep }: any) => (
      <WalkthroughContent currentStep={currentStep} totalSteps={5} />
    ),
    position: 'center' as const,
  },
  {
    selector: '[data-tour="stats"]',
    content: ({ currentStep }: any) => (
      <WalkthroughContent currentStep={currentStep} totalSteps={5} />
    ),
    position: 'bottom' as const,
  },
  {
    selector: '[data-tour="quick-actions"]',
    content: ({ currentStep }: any) => (
      <WalkthroughContent currentStep={currentStep} totalSteps={5} />
    ),
    position: 'top' as const,
  },
  {
    selector: '[data-tour="recent-sales"]',
    content: ({ currentStep }: any) => (
      <WalkthroughContent currentStep={currentStep} totalSteps={5} />
    ),
    position: 'top' as const,
  },
  {
    selector: '[data-tour="benefits"]',
    content: ({ currentStep }: any) => (
      <WalkthroughContent currentStep={currentStep} totalSteps={5} />
    ),
    position: 'top' as const,
  },
];

interface WalkthroughProviderProps {
  children: React.ReactNode;
}

export const WalkthroughProvider: React.FC<WalkthroughProviderProps> = ({ children }) => {
  return (
    <TourProvider
      steps={steps}
      styles={{
        popover: (base) => ({
          ...base,
          '--reactour-accent': 'hsl(var(--primary))',
          borderRadius: '12px',
          padding: 0,
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
        }),
        badge: () => ({
          display: 'none',
        }),
      }}
      padding={10}
    >
      {children}
    </TourProvider>
  );
};
